import axios from '../common/axios';

const SERVICE_PREFIX = 'service';

async function sendTestNotification(): Promise<any> {
  return axios.get(`${SERVICE_PREFIX}/sentNotifications`).then((res) => res.data);
}

export { sendTestNotification };
